import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import Select, { MenuPlacement } from 'react-select';

type CustomSelectProps = {
  options: { label: string; value: string | boolean; isDisabled?: boolean }[];
  control?: Control<any>;
  name: string;
  label?: string;
  labelStyle?: string;
  controlStyle?: string;
  error?: string;
  onCustomChange?: (value?: string | boolean | number) => void;
  value?: string;
  menuPlacement?: MenuPlacement;
  isSearchable?: boolean;
  isDisabled?: boolean;
};

export const CustomSelect: FC<CustomSelectProps> = ({
  options,
  control,
  label,
  name,
  labelStyle,
  controlStyle,
  value,
  error,
  menuPlacement,
  isSearchable = false,
  onCustomChange,
  isDisabled,
}) => {
  return control ? (
    <div className={`w-full relative ${controlStyle}`}>
      {label && (
        <label
          className={`text-sm text-gray-400 ${labelStyle}`}
          htmlFor="responseType"
        >
          {label}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <Select
              {...field}
              isDisabled={isDisabled}
              options={options}
              isSearchable={isSearchable}
              menuPlacement={menuPlacement}
              components={{
                IndicatorSeparator: () => null,
              }}
              styles={{
                control: (provided) => ({
                  ...provided,
                  padding: '2px 3px 2px 3px',
                  borderWidth: '2px',
                  borderColor: 'rgb(229 231 235)',
                }),
              }}
              value={options.find((c) => {
                if (typeof c.value === 'string') {
                  return c.value === String(field.value);
                }
                return c.value === field.value;
              })}
              onChange={(selectedOption) => {
                field.onChange(selectedOption?.value);
                onCustomChange?.(selectedOption?.value);
              }}
            />
            {fieldState.error && (
              <p className="text-red-500 italic text-xs">
                {fieldState.error.message}
              </p>
            )}
          </>
        )}
      />
      {error && <p className="text-red-500 italic text-xs">{error}</p>}
    </div>
  ) : (
    <div className="w-full relative">
      <Select
        menuPlacement="auto"
        options={options}
        isSearchable={isSearchable}
        styles={{
          control: (provided) => ({
            ...provided,
            borderRadius: '4px',
          }),
        }}
        value={options.find((c) => {
          return c.value === value;
        })}
        onChange={(selectedOption) => {
          if (!selectedOption) return;
          if (typeof selectedOption?.value === 'string')
            onCustomChange && onCustomChange(selectedOption.value);
        }}
      />
    </div>
  );
};
